// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3NaEH","select":"Header_select__1ByXg","clinic":"Header_clinic__1s0zu"};